import { takeLatest, put } from 'redux-saga/effects';
import { createAxios } from '../utils/utils';
import { ANDROID_CLASS_CLASSES, ANDROID_CLASS_CLASS_APPS } from '../config';
import {
  GET_ANDROID_CLASSES_LIST,
  GET_ANDROID_CLASSES_LIST_SUCCESS,
  GET_ANDROID_CLASS_APPS,
  GET_ANDROID_CLASS_APPS_SUCCESS,
} from '../constants/acategory';

function* fetchAClassesList(params) {
  try {
    const axios = yield createAxios();
    const res = yield axios.get(ANDROID_CLASS_CLASSES, { params: params.param });
    if (res.data.status === 0) {
      yield put({
        type: GET_ANDROID_CLASSES_LIST_SUCCESS,
        data: {
          list: res.data.data,
          code: params.param.code,
        }
      });
    }
  } catch (error) {
    // throw error;
  }
}

function* fetchAClassApps(params) {
  try {
    yield put({ type: GET_ANDROID_CLASS_APPS_SUCCESS, data: { loading: true } });
    const axios = yield createAxios();
    const res = yield axios.get(ANDROID_CLASS_CLASS_APPS, { params: params.param });
    if (res.data.status === 0) {
      const data = { ...res.data.data, loading: false, params: params.param };
      yield put({ type: GET_ANDROID_CLASS_APPS_SUCCESS, data });
    }
  } catch (error) {
    throw error;
  }
}

export function* watchFetchAClassApps() {
  yield takeLatest(GET_ANDROID_CLASS_APPS, fetchAClassApps);
}

export function* watchFetchAClassesList() {
  yield takeLatest(GET_ANDROID_CLASSES_LIST, fetchAClassesList);
}
